import styled from 'styled-components'
const fontSize = localStorage.getItem('fontSize')

export const CardsContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 991px) {
    margin-bottom : 0px;
  }


`
export const MainCardsContainer = styled.div`
  display: flex;
  gap: 3%;
  width: 80%;
`
export const MainCards = styled.div`
  width: 67%;
  color: #101e8e;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-transform:uppercase;
  div {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
`

export const MainCard = styled.div`
  background: #fff;
  width: 40%;
  color: #101e8e;
  min-height: 120px;
  padding: 0.3rem;
  font-size: 0.7rem;
  border-left: 0.4rem solid ${props => props.color || 'rgb(16, 30, 142)'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor:pointer;
`

export const MainCardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  & > span {
    font-weight: 700;
    font-size: calc(${fontSize} - 0.25rem);
    width: 100%;
  }
  div {
    background: #eee;
    height: 50px;
    width: 70px;
    border-radius: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 30px;
      height: 30px;
    }
  }
`

export const MainCardDetails = styled.div`
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  p {
    font-size: calc(${fontSize} + 2rem);
  }
  .details {
    display: flex;
    flex-direction: column;

    button {
      border: none;
      color: #101e8e;
      background: #eee;
      padding: 0.2rem;
    }
    .p {
      font-size: 0.7rem;
      color: #101e8e;
      height: 5px;
    }
    span {
      color: #d46b6b;
      font-size: calc(${fontSize} - 0.4rem);
    }
  }
`

export const BaseCardsContainer = styled.div`
  display: flex;
  gap: 1%;
  width: 90%;
  margin: auto;

  @media (max-width: 991px) {
    display: block;
  }

`

export const BaseCard = styled.div`
  width: 58%;
  background: #fff;
  min-height: 20vh;
  display: flex;
  flex-direction: column;
  gap: 1em;
  align-items: center;
  padding-bottom: 1em;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin-top:1rem;
  }
  .viewall{
    font-style: normal;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1rem;
 
    text-align: center;
    text-transform: uppercase;

    color: #101E8E;
    flex: 1;
    cursor: pointer;
    text-align: end;
  }
  h3 {
    color: #6caf5c;
    width: 90%;
    flex: 3;
    font-size: 2rem;
  }
  p {
    color: #101e8e;
  }

  @media (max-width: 991px) {
    margin-top: 10px;
    width: 100%;
    // margin-left: -5.5%;
    margin-bottom: 10px;


table{
  width: 100%;
  font-size: 12px;
}

h3{
  font-weight: 600;
}

.viewall{
  font-weight: 600;
font-size: 12px;
}

  }

`

export const Table = styled.table`
  border-collapse: collapse;
  width: 90%;
  color: #101e8e;
  background: #fff;
  &:nth-child(3) {
    align: left;
  }
`

export const Td = styled.td`
  border-bottom: 1px solid #ddd;
  padding: 8px;
  width: 50%;
  font-size: calc(${fontSize} - 0.3rem);
`

export const Th = styled.th`
  padding: 6px;
  width: auto;
  font-size: calc(${fontSize} - 0.3rem);
  font-weight: 800;
  text-align: left;
  background-color: #f6fafb;
  color: #101e8e;
`

export const Tr = styled.tr`
  height: 3rem;
  &:hover {
    background-color: #ddd;
  }
`

export const MyFavorites = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-start;
  gap: 1rem;
  padding: 0rem 1rem 1rem 1rem;
  width: 30%;
  background: #fff;
  span {
    color: #62aa51;
    align-self: flex-start;
    font-weight: 700;
    margin-left: 0.9rem;
    line-height: 3;
    font-size: calc(${fontSize} + 0.5rem);
    width: 100%;
  }
  p {
    color: #62aa51;
    align-self: flex-start;
    font-weight: 700;
    margin-left: 0.9rem;
    font-size: calc(${fontSize} + 0.5rem);
  }

  @media (max-width: 991px) {
    width: 100%;
    margin-left: -5.5%;
    margin-top: 10px;
  }

`

export const MyFavoritesCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  background: #eee;
  padding: 0.5rem;
  font-weight: 700;
  font-size: 0.9rem;
  svg {
    color: #62aa51;
  }

  @media (max-width: 991px) {
  width: 100%;
  }

`
